export default {
  metaTitle: 'Cross-Store Spend & Save Management',
  pageTitle: 'Cross-Store Spend & Save Management',
  radio1: 'Processing',
  radio2: 'Not yet started',
  creationTime: 'Creation time',
  typeOfEvent: 'Type of Event',
  eventInPeriod: 'Event in Period',
  activity1: '促销活动',
  activity2: '活动展示名',
  activity3: '促销类型',
  activity4: '满',
  activity5: '减',
  activity6: '活动起始时间',
  activity7: '抵扣选项',
  activity8: '适用店铺',
  activity9: '创建的时间',
  activity10: '商品报名',
  typeList1: 'All',
  typeList2: 'Reduction on Amount',
  activitylist: 'Reduction on Amount',
  statusDisplaylist1: '待审核',
  statusDisplaylist2: 'Not yet started',
  statusDisplaylist3: 'Processing',
  statusDisplaylist4: '已过期',
  statusDisplaylist5: '取消或拒绝',
  columns1: 'Promotion registration',
  columns2: 'Event name',
  columns3: 'Creation time',
  columns4: 'Event review time',
  columns5: 'Type of Event',
  columns6: 'Promotional content',
  columns7: 'Status',
  columns8: 'Products applied',
  columns9: 'Details',
  btn1: 'Details',
  btn2: '商品',
  btn3: '可报名品类',
  type1: '满减',
  disable1: '禁用店铺券',
  disable2: '禁用平台券',
  disable3: '禁用Coins',
  allStore: '所有店铺'
}
